import { html } from 'lit';
import componentStyles from './lightbox.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Lightbox extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      /**
       * Main content area title
       */
      type: { type: String },
    };
  }

  constructor() {
    super();
    this.type = 'image';
  }

  firstUpdated() {
    super.firstUpdated();
    // @TODO: attach events only once
    document
      .querySelector('#lightbox__close')
      .addEventListener('click', this.closeModal);
    document
      .querySelector('#lightbox__container')
      .addEventListener('click', this.closeModal);

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        this.closeModal(event);
      }
    });
  }

  closeModal(event) {
    if (event.target.nodeName === 'IMG') {
      return;
    } else {
      const lightboxContainer = document.querySelector('#lightbox__container');
      lightboxContainer.classList.remove('lightbox--open');
    }
  }

  openModal() {
    const lightboxContainer = document.querySelector('#lightbox__container');
    const lightboxContent = document.querySelector('#lightbox__content');
    const modalContent = this.shadowRoot
      .querySelector('slot[name="content"]')
      .assignedNodes();

    while (lightboxContent.firstChild) {
      lightboxContent.removeChild(lightboxContent.lastChild);
    }

    modalContent.forEach(item => {
      lightboxContent.appendChild(item.cloneNode(true));
    });

    lightboxContainer.classList.add('lightbox--open');
  }

  render() {
    return html`
      <div class="lightbox lightbox--${this.type}">
        <div class="lightbox__preview" @click="${this.openModal}">
          <slot name="preview"></slot>
        </div>
        <div class="lightbox__modal">
          <slot name="content"></slot>
        </div>
      </div>
    `;
  }
}
customElements.define('hf-lightbox', Lightbox);
